<div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="h1 pr-16">Servicios</div>
</div>

<mat-form-field class="full-width">
    <span matPrefix>
        <mat-icon>search</mat-icon>
    </span>
    <input matInput #filter placeholder="Buscar..." />
</mat-form-field>

<div>
    <mat-table
        class="servicios-tabla"
        #table
        [dataSource]="dataSource"
        matSort
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <ng-container matColumnDef="descripcion">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Servicio</mat-header-cell
            >
            <mat-cell *matCellDef="let servicio">
                <p style="width: 95%">
                    <strong
                        >{{ servicio.descripcion }}
                        <span [hidden]="servicio.atributos.length === 0"
                            >-</span
                        >
                        {{ servicio.atributos.join(", ") }}</strong
                    >
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sucursal">
            <mat-header-cell *matHeaderCellDef>Sucursal</mat-header-cell>
            <mat-cell *matCellDef="let servicio">
                <mat-form-field class="category-selector" style="width: 90%">
                    <mat-select
                        [(ngModel)]="servicio.sucursalSeleccionada"
                        (selectionChange)="calcularPecio($event, servicio)"
                    >
                        <mat-option
                            *ngFor="let sucursal of sucursales"
                            [value]="sucursal.id"
                        >
                            {{ sucursal.nombre }} - {{ sucursal.direccion }},
                            {{ sucursal.comuna.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="valorUnitarioUF">
            <mat-header-cell *matHeaderCellDef>Valor Unitario</mat-header-cell>
            <mat-cell *matCellDef="let servicio">
                <div
                    *ngIf="servicio.cargandoPrecio"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                >
                    <mat-spinner color="accent" diameter="20"></mat-spinner>
                </div>
                <div *ngIf="servicio.precio" class="text-right">
                    <p class="mb-0">
                        <strong
                            >UF {{ servicio.precio.valorMinimoUf }} -
                            {{ servicio.precio.valorMaximoUf }}
                        </strong>
                    </p>

                    <small class="primary p-4"
                        >{{
                            servicio.precio.valorMinimoClp
                                | currency: "CLP":"symbol-narrow"
                        }}
                        -
                        {{
                            servicio.precio.valorMaximoClp
                                | currency: "CLP":"symbol-narrow"
                        }}</small
                    >
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="agregar">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let servicio">
                <p class="text-truncate">
                    <button
                        mat-icon-button
                        type="button"
                        color="accent"
                        (click)="agregar(servicio)"
                        [disabled]="
                            !servicio.sucursalSeleccionada || !servicio.precio
                        "
                    >
                        <mat-icon>add</mat-icon>
                    </button>
                </p>
            </mat-cell>
        </ng-container>

        <mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>

        <!--<tr mat-row *matRowDef="let servicio; columns: displayedColumns"></tr>-->

        <mat-row *matRowDef="let servicio; columns: displayedColumns">
        </mat-row>
    </mat-table>
</div>
<mat-paginator
    #paginator
    [length]="dataSource?.filteredData?.length"
    [pageIndex]="0"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 100]"
>
</mat-paginator>
